import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// ============== COUNTRIES ==============

export const getAllCountries = async (continent = null) => {
  try {
    const url = continent 
      ? `${BACKEND_URL}/api/countries?continent=${continent}`
      : `${BACKEND_URL}/api/countries`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error fetching countries:', error);
    throw error;
  }
};

export const getCountryById = async (id) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/countries/${id}`);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error fetching country:', error);
    throw error;
  }
};

// ============== BLOG POSTS ==============

export const getAllBlogPosts = async (countryId = null) => {
  try {
    const url = countryId
      ? `${BACKEND_URL}/api/blog?country_id=${countryId}`
      : `${BACKEND_URL}/api/blog`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error fetching blog posts:', error);
    throw error;
  }
};

export const getBlogPostById = async (id) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/blog/${id}`);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error fetching blog post:', error);
    throw error;
  }
};

// ============== RECIPES ==============

export const getAllRecipes = async (continent = null, countryId = null) => {
  try {
    let url = `${BACKEND_URL}/api/recipes`;
    const params = [];
    if (continent) params.push(`continent=${continent}`);
    if (countryId) params.push(`country_id=${countryId}`);
    if (params.length > 0) url += `?${params.join('&')}`;
    
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      if (process.env.NODE_ENV === 'development') console.error('Error fetching recipes:', error);
    }
    throw error;
  }
};

export const getRecipeById = async (id) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/recipes/${id}`);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error('Error fetching recipe:', error);
    throw error;
  }
};
